import React from "react";
import { DialogContent, Typography } from "@mui/material";
import { Button, Modal } from "components/haven-design";
import { DialogActions } from "components/haven-design/modal/dialog";

export type Props = {
  isOpen: boolean,
  message: string;
  onSubmit(event: React.MouseEvent | React.KeyboardEvent): void,
  onDismiss(event: React.MouseEvent | React.KeyboardEvent): void,
  buttonColor?: "primary" | "secondary" | "tertiary" | "dangerous",
  buttonText?: string,
  cancelEnabled?: boolean,
  secondaryMessage?: string,
};

const ModalComponent: React.FC<Props> = ({
  isOpen,
  onSubmit,
  onDismiss,
  message,
  secondaryMessage,
  buttonColor,
  buttonText,
  cancelEnabled,
}) => (
  <Modal isOpen={isOpen} onRequestClose={onDismiss} title={message}>
    <DialogContent>
      {secondaryMessage && <Typography variant="subtitle1">{secondaryMessage}</Typography>}
    </DialogContent>
    <DialogActions>
      {cancelEnabled && <Button color="secondary" size="L" onClick={onDismiss}>
        Cancel
      </Button>}
      <Button color={buttonColor ?? "primary"} size="L" onClick={onSubmit}>
        {buttonText ?? "Dismiss"}
      </Button>
    </DialogActions>
  </Modal>
);

export default ModalComponent;
